import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import * as UrlConstants from "constants/urls";
import Button from "components/common/Button";
import { useSpaceGuestLogin } from "hooks/spaceHooks";
import CustomToast from "components/common/CustomToast";
import toast from "react-hot-toast";
import SpaceGuestAuthLayout from "../SpaceGuestAuthLayout";

export default function SpacesGuestLoginEmailSent() {
    const { email } = useLocation().state || {};
    const navigate = useNavigate();

    const [spaceGuestLoginMutation, spaceGuestLoginMutationResult] = useSpaceGuestLogin();

    async function handleResendLink(email: string) {
        try {
            await spaceGuestLoginMutation({ email });

            toast.custom((t) => (
                <CustomToast t={t} message="Link resent successfully" type="success" />
            ));
        } catch (error) {
            toast.custom((t) => <CustomToast t={t} message={error?.message} type="error" />);
        }
    }

    if (!email) {
        navigate(UrlConstants.SPACES_GUEST_LOGIN);
        return;
    }

    return (
        <SpaceGuestAuthLayout>
            <div className="space-y-5 w-full max-w-[475px] !h-fit bg-white rounded-[8px] p-[32px] flex flex-col items-center justify-center">
                <div className="flex items-center justify-center w-fit">
                    <i className="ri-mail-line text-2xl text-black"></i>
                </div>

                <div>
                    <p className="text-2xl font-rocGroteskMedium text-center">Check your email</p>
                    <p className="text-sm text-slate-400 font-rocGroteskMedium text-center">
                        We’ve sent a secure magic link to
                        <br /> {email}. Please check your inbox and click the link to log back into
                        your space.f you don’t see it, check your spam or junk folder.
                    </p>
                </div>

                <div className="grid grid-cols-2 gap-2 w-full">
                    <Button
                        btnText="Change Email"
                        onClick={() => {
                            navigate(UrlConstants.SPACES_GUEST_LOGIN);
                        }}
                        btnClassname="!bg-[#F4F5F7] !text-[#142837] !w-full"
                        disabled={spaceGuestLoginMutationResult?.isLoading}
                    />

                    <Button
                        btnText="Resend Link"
                        isLoading={spaceGuestLoginMutationResult?.isLoading}
                        onClick={() => {
                            handleResendLink(email);
                        }}
                        btnClassname="!bg-[#F4F5F7] !text-[#142837] !w-full"
                    />
                </div>
            </div>
        </SpaceGuestAuthLayout>
    );
}
